import type { SVGProps } from "react";
export const AddUserIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="fill-current"
    {...props}
  >
    <path
      d="M12 13.5C12.9946 13.5 13.9481 13.8954 14.6514 14.5986C15.3546 15.3019 15.75 16.2554 15.75 17.25V18.75C15.75 19.1642 15.4142 19.5 15 19.5C14.5858 19.5 14.25 19.1642 14.25 18.75V17.25C14.25 16.6533 14.0128 16.0811 13.5908 15.6592C13.2217 15.29 12.7376 15.0622 12.2227 15.011L12 15H6.75C6.15326 15 5.58114 15.2372 5.15918 15.6592C4.73722 16.0811 4.5 16.6533 4.5 17.25V18.75C4.5 19.1642 4.16421 19.5 3.75 19.5C3.33579 19.5 3 19.1642 3 18.75V17.25C3 16.2554 3.39537 15.3019 4.09863 14.5986C4.80189 13.8954 5.75544 13.5 6.75 13.5H12Z"
      fill="currentColor"
    />
    <path
      d="M18 8.25C18.4142 8.25 18.75 8.58579 18.75 9V10.5H20.25C20.6642 10.5 21 10.8358 21 11.25C21 11.6642 20.6642 12 20.25 12H18.75V13.5C18.75 13.9142 18.4142 14.25 18 14.25C17.5858 14.25 17.25 13.9142 17.25 13.5V12H15.75C15.3358 12 15 11.6642 15 11.25C15 10.8358 15.3358 10.5 15.75 10.5H17.25V9C17.25 8.58579 17.5858 8.25 18 8.25Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.375 4.5C11.4461 4.5 13.125 6.17893 13.125 8.25C13.125 10.3211 11.4461 12 9.375 12C7.30393 12 5.625 10.3211 5.625 8.25C5.625 6.17893 7.30393 4.5 9.375 4.5ZM9.375 6C8.13236 6 7.125 7.00736 7.125 8.25C7.125 9.49264 8.13236 10.5 9.375 10.5C10.6176 10.5 11.625 9.49264 11.625 8.25C11.625 7.00736 10.6176 6 9.375 6Z"
      fill="currentColor"
    />
  </svg>
);
